import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=b7140632&scoped=true&"
var script = {}
import style0 from "./Section.vue?vue&type=style&index=0&id=b7140632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7140632",
  null
  
)

export default component.exports